import axios from '@/plugins/axios';

const BANNER = '/banner';
const BANNER_CLICK_HISTORY = "/banner/click-history";
const BANNER_IMPRESSION_HISTORY = "/banner/impression-history";

export async function getBanner(params) {
  try {
    const { data } = await axios.get(BANNER, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function clickBanner(payload) {
  try {
    const { data } = await axios.post(`${BANNER_CLICK_HISTORY}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function impressionBanner(payload) {
  try {
    const { data } = await axios.post(`${BANNER_IMPRESSION_HISTORY}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
